import React, { Component, Suspense, lazy } from 'react'
import { Route, Switch } from 'wouter'
import HistogramC from '../containers/HistogramC'
import Header from './Header'
import Head from '../containers/Head'
//import SocialAuthRedirect from './Login/SocialAuthRedirect'
import MainDialog from '../containers/MainDialog';
import Users from '../containers/Users'
import JHReviewsPC from '../containers/JH/JHReviewsPC'
import PersonalJourneyPC from '../containers/JH/PersonalJourneyPC'
import JHSettings from '../containers/JH/JHSettings'
import JHPaymentLinkPC from '../containers/JH/JHPaymentLinkPC'
import GlobalContainer from '../containers/GlobalContainer'
import Interviews from './Interviews/Interviews'
import SynamediaClientsPC from '../containers/SynamediaClientsPC'
//import Events from './events/Events'
import JHPublishesPC from '../containers/JH/JHPublishesPC'
import JHPC from '../containers/JH/JHPC'
import DashboardPC from '../containers/JH/DashboardPC'
//import BflClientsPC from '../containers/BflClientsPC'
import JobsFound from './JH/JobsFound'
import SynamediaClientsStatus from './JH/SynamediaClientsStatus'
import Leads from './JH/Leads'
import InterviewsReport from './JH/InterviewsReport'
import Kpis from './JH/Kpis'
import DashboardJH from './JH/DashboardJH'
import MarketingPosts from './JH/MarketingPosts'
import MarketingCalendar from './JH/MarketingCalendar'
//import JSAdminPC from '../containers/JSAdminPC'
import EmailsTemplates from './EmailsTemplates'
import JourneyViewC from '../containers/JH/JourneyViewC'
import Newinterviews from './Interviews/Newinterviews'
import JobhuntRecruiters from './JH/JobhuntRecruiters'
//import MarketingSettings from './JH/MarketingSettings'
//import Company from '../containers/Company'

//const Templates = lazy(() => import('../containers/Templates'));
const Payments = lazy(() => import('../containers/Payments'));
const Privacy = lazy(() => import('./Privacy'));
const Terms = lazy(() => import('./Terms'));
const Settings = lazy(() => import('../containers/Settings'));
const Notifications = lazy(() => import('../containers/Notifications'));
const SendPushContainer = lazy(() => import('../containers/SendPushContainer'));
const JSSetings = lazy(() => import('../containers/JSSetings'));
const Statistics = lazy(() => import('./JH/Statistics'));
const Questionnaire = lazy(() => import('./JH/Questionnaire'));
const Dashboard = lazy(() => import('./JH/Dashboard'));
//const SynamediaClientsNew = lazy(() => import('./SynamediaClientsNew'));
const DashboardMain = lazy(() => import('./DashboardMain'));
const ScheduleMeetingSlots = lazy(() => import('./JH/personalJourney/ScheduleMeetingSlots'));

export default class App extends Component {
    render() {
        const history = this.props.history
        const isJobHunt = this.props.isJobHunt
        const isBusiness = (window.VIEW_TYPE === 'business')

        return (
            <React.Fragment>
                <Head/>
                <MainDialog/>

                {(window.VIEW_TYPE === 'journey')?<JourneyViewC history={history}/>:<>
                <Header isJobHunt={isJobHunt }/>
                <main>
                    <Suspense fallback={<div>Loading page...</div>}>
                        <Switch>
                            {/*<Route path="/socialauthredirect/" component={SocialAuthRedirect} />
                            <Route path="/signupConfrimation/" render={(props) => <SocialAuthRedirect {...props} signupConfrimation />}/>*/}
                            <Route path="/profile">
                                {(params) => <HistogramC match={{ params }} histogramType={'profile'} />}
                            </Route>

                            <Route path="/reports">
                                {(params) => <HistogramC match={{ params }} histogramType={'reports'} />}
                            </Route>
                            <Route path="/templates/:template">
                                {(params) => <JHPC match={{ params }}><EmailsTemplates/></JHPC>}
                            </Route>
                            <Route path="/templates">
                                {(params) => <JHPC match={{ params }}><EmailsTemplates/></JHPC>}
                            </Route>
                            
                            <Route path="/users/:userId">
                                {(params) => <Users match={{ params }}/>}
                            </Route>
                            <Route path="/users">
                                {(params) => <Users match={{ params }}/>}
                            </Route>
                            
                            {/*<Route path="/companies/:company" component={Company}/>*/}

                            <Route path="/payments" component={Payments}/>

                            <Route path="/privacy" component={Privacy}/> 
                            <Route path="/terms" component={Terms}/> 

                            <Route path="/settings" component={Settings}/> 
                            <Route path="/notifications" component={Notifications}/> 
                            <Route path="/saveditems"> 
                                {(params) => <HistogramC match={{ params }} histogramType={'saveditems'} />}
                            </Route>
                            <Route path="/sendpushnotifications" component={SendPushContainer}/> 
                            <Route path="/jssettings" component={JSSetings}/> 

                            <Route path="/jobhunt-reviews" component={JHReviewsPC}/> 

                            <Route path="/jobhunt-statistics">
                                <JHPC><Statistics/></JHPC>
                            </Route>
                            <Route path="/jobs-found">
                                <JHPC><JobsFound/></JHPC>
                            </Route>

                            <Route path="/jobhunt-recruiters">
                                <JHPC><JobhuntRecruiters/></JHPC>
                            </Route>

                            <Route path="/jobhunt-settings" component={JHSettings}/> 
                            <Route path="/jobhunt-payment" component={JHPaymentLinkPC}/>
                            <Route path="/jobhunt-publishes" component={JHPublishesPC}/>                            

                            {/*<Route path="/faq" component={Faq}/> */}

                            <Route path="/myJobs">
                                {(params) => <HistogramC match={{ params }} histogramType={'myJobs'} />}
                            </Route>
                            <Route path="/activity/:activityView">
                                {(params) => <HistogramC match={{ params }} histogramType={'activity'} />}
                            </Route>
                            <Route path="/activity">
                                {(params) => <HistogramC match={{ params }} histogramType={'activity'} />}
                            </Route>
                            <Route path="/newPassword">
                                {(params) => <HistogramC match={{ params }} histogramType={'main'} newPassword/>}
                            </Route>

                            <Route path="/jobs/:job">
                                {(params) => <HistogramC match={{ params }} histogramType={'jobs'}/>}
                            </Route>
                            <Route path="/jobs">
                                {(params) => <HistogramC match={{ params }} histogramType={'jobs'}/>}
                            </Route>
                            <Route path="/resumes/:job">
                                {(params) => <HistogramC match={{ params }} histogramType={'resumes'}/>}
                            </Route>
                            <Route path="/resumes">
                                {(params) => <HistogramC match={{ params }} histogramType={'resumes'}/>}
                            </Route>

                            <Route path="/interviews/:param">
                                {(params) => <GlobalContainer match={{ params }}><Interviews/></GlobalContainer>}
                            </Route>
                            <Route path="/interviews">
                                {(params) => <GlobalContainer match={{ params }}><Interviews/></GlobalContainer>}
                            </Route>
                            <Route path="/newinterviews">
                                <GlobalContainer><div className="pageMainContainer fullHeight"><Newinterviews/></div></GlobalContainer>
                            </Route>

                            {/*<Route path="/events/:eventUrl" render={(props) => <GlobalContainer {...props}><Events/></GlobalContainer>}/> */}

                            <Route path="/synamediaClients">
                                <SynamediaClientsPC company='Synamedia'/>
                            </Route>
                            <Route path="/bflClients">
                                <SynamediaClientsPC company='Bfl'/>
                            </Route>

                            <Route path="/jobhunt-clients-status" component={SynamediaClientsStatus}/> 
                            <Route path="/leads">
                                <JHPC><Leads/></JHPC>
                            </Route>
                            <Route path="/questionnaires">
                                <JHPC><Questionnaire/></JHPC>
                            </Route>
                            <Route path="/interviews-report">
                                <JHPC><InterviewsReport/></JHPC>
                            </Route>

                            <Route path="/dashboard">
                                <JHPC><Dashboard/></JHPC>
                            </Route>

                            {/*<Route path="/interviews/:job" render={(props) => <HistogramC {...props} histogramType={'interviews'} />}/>
                            <Route path="/interviews" render={(props) => <HistogramC {...props} histogramType={'interviews'} />}/>*/}
                            {/*<Route path="/companies/:job" render={(props) => <HistogramC {...props} histogramType={'companies'} />}/>
                            <Route path="/companies" render={(props) => <HistogramC {...props} histogramType={'companies'} />}/>
                            <Route path="/reviews/:job" render={(props) => <HistogramC {...props} histogramType={'companies'} cardContent={'Reviews'}/>}/>
                            <Route path="/interviews/:job" render={(props) => <HistogramC {...props} histogramType={'companies'} cardContent={'Interviews'}/>}/>*/}

                            <Route path="/jobhunt-users/:job">
                                {(params) => <HistogramC match={{ params }} histogramType={'jobhuntUsers'}/>}
                            </Route>
                            <Route path="/jobhunt-users">
                                {(params) => <HistogramC match={{ params }} histogramType={'jobhuntUsers'}/>}
                            </Route>

                            <Route path="/kpis">
                                <JHPC><Kpis/></JHPC>
                            </Route>
                            <Route path="/Journey-table-view">
                                <DashboardPC><DashboardJH/></DashboardPC>
                            </Route>
                            <Route path="/personal-journey" component={PersonalJourneyPC}/> 

                            <Route path="/marketing-posts">
                                <JHPC><MarketingPosts/></JHPC>
                            </Route>
                            <Route path="/marketing-calendar">
                                <JHPC><MarketingCalendar/></JHPC>
                            </Route>
                            <Route path="/marketing-dashboard">
                                <JHPC><DashboardMain/></JHPC>
                            </Route>

                            <Route path="/schedule_meeting">
                                {(params) => <GlobalContainer match={{ params }}><ScheduleMeetingSlots/></GlobalContainer>}
                            </Route>
                            {/*<Route path="/marketing-settings" render={(props) => <JHPC {...props}><MarketingSettings/></JHPC>}/>*/}

                            <Route>
                                <>
                                    {!isJobHunt&&!isBusiness&&<HistogramC histogramType={'main'} />}
                                    {isJobHunt&&<DashboardPC><Kpis/></DashboardPC>}
                                    {isBusiness&&<SynamediaClientsPC/>}
                                </>
                            </Route>
                        </Switch>
                    </Suspense>
                </main>
                </>}
            </React.Fragment>
        )
    }
}